import { isHostComponent } from '@mui/base';

const shouldSpreadAdditionalProps = Slot => {
  return !Slot || !isHostComponent(Slot);
};

export default shouldSpreadAdditionalProps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/utils/shouldSpreadAdditionalProps.js
// module id = 560
// module chunks = 1